/**
 * Modern Minimalist Palette
 * Clean, sophisticated, contemporary
 */

import { ThemeColors } from '../../assets/theme';

export const minimalistLight: ThemeColors = {
  // Primary palette - Deep charcoal with slate
  primary: '#2C3E50',
  primaryLight: '#34495E',
  primaryDark: '#1A252F',

  // Secondary palette - Muted blue-gray and sage
  secondary: '#5B7FA4',
  secondaryLight: '#7A9BC4',
  secondaryDark: '#3D5F7F',

  // Accent colors - Single vibrant color for CTAs
  accent: '#E63946',
  accentLight: '#EF5A66',
  accentDark: '#D62836',

  // Neutral palette - Pure whites and cool grays
  background: '#FAFAFA',
  surface: '#FFFFFF',
  surfaceHover: '#F5F5F5',

  // Text colors
  text: '#1A1A1A',
  textSecondary: '#6B6B6B',
  textMuted: '#9B9B9B',

  // Status colors
  success: '#28A745',
  warning: '#FFC107',
  error: '#DC3545',
  info: '#17A2B8',

  // Border and divider
  border: '#E0E0E0',
  borderLight: '#F0F0F0',
  divider: '#D0D0D0',

  // Shadows - Neutral gray
  shadow: 'rgba(0, 0, 0, 0.08)',
  shadowHover: 'rgba(0, 0, 0, 0.12)',
  shadowDark: 'rgba(0, 0, 0, 0.16)',

  // Overlays
  overlay: 'rgba(0, 0, 0, 0.5)',
  overlayLight: 'rgba(0, 0, 0, 0.1)',

  // Gradients
  gradientPrimary: 'linear-gradient(135deg, #2C3E50 0%, #34495E 100%)',
  gradientSecondary: 'linear-gradient(135deg, #5B7FA4 0%, #7A9BC4 100%)',
  gradientBackground: 'linear-gradient(135deg, #FAFAFA 0%, #F5F5F5 100%)',

  // Glass morphism
  glass: 'rgba(255, 255, 255, 0.25)',
  glassBorder: 'rgba(44, 62, 80, 0.1)',
  glassShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.15)',

  // ICOM specific (adapted)
  icomBlue: '#2C3E50',
  icomGold: '#E63946',
  icomNavy: '#1A252F',
  icomLightBlue: '#F0F4F8',
  icomWarmGray: '#F5F5F5',
};

export const minimalistDark: ThemeColors = {
  // Primary palette
  primary: '#34495E',
  primaryLight: '#4A5568',
  primaryDark: '#2C3E50',

  // Secondary palette
  secondary: '#7A9BC4',
  secondaryLight: '#95B3D4',
  secondaryDark: '#5B7FA4',

  // Accent colors
  accent: '#EF5A66',
  accentLight: '#F57580',
  accentDark: '#E63946',

  // Neutral palette - Dark grays
  background: '#0F0F0F',
  surface: '#1A1A1A',
  surfaceHover: '#252525',

  // Text colors
  text: '#F0F0F0',
  textSecondary: '#B0B0B0',
  textMuted: '#808080',

  // Status colors
  success: '#4CAF50',
  warning: '#FFB300',
  error: '#EF5350',
  info: '#29B6F6',

  // Border and divider
  border: '#333333',
  borderLight: '#252525',
  divider: '#404040',

  // Shadows
  shadow: 'rgba(0, 0, 0, 0.4)',
  shadowHover: 'rgba(0, 0, 0, 0.5)',
  shadowDark: 'rgba(0, 0, 0, 0.6)',

  // Overlays
  overlay: 'rgba(0, 0, 0, 0.75)',
  overlayLight: 'rgba(0, 0, 0, 0.4)',

  // Gradients
  gradientPrimary: 'linear-gradient(135deg, #2C3E50 0%, #34495E 100%)',
  gradientSecondary: 'linear-gradient(135deg, #5B7FA4 0%, #7A9BC4 100%)',
  gradientBackground: 'linear-gradient(135deg, #0F0F0F 0%, #1A1A1A 100%)',

  // Glass morphism
  glass: 'rgba(26, 26, 26, 0.8)',
  glassBorder: 'rgba(255, 255, 255, 0.1)',
  glassShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.6)',

  // ICOM specific
  icomBlue: '#34495E',
  icomGold: '#EF5A66',
  icomNavy: '#1A252F',
  icomLightBlue: '#252525',
  icomWarmGray: '#252525',
};
